"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApprovalSheetManagementFooter = void 0;
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var react_intl_1 = require("react-intl");
var Settings_1 = __importDefault(require("@material-ui/icons/Settings"));
var PlayArrow_1 = __importDefault(require("@material-ui/icons/PlayArrow"));
var Stop_1 = __importDefault(require("@material-ui/icons/Stop"));
var Save_1 = __importDefault(require("@material-ui/icons/Save"));
var Close_1 = __importDefault(require("@material-ui/icons/Close"));
var Add_1 = __importDefault(require("@material-ui/icons/Add"));
var styles_1 = require("@material-ui/core/styles");
var common_1 = require("../../../common");
var utils_1 = require("../../../utils");
var ApprovalSheetManagementContext_1 = require("../../../context/ApprovalSheetManagementContext");
var context_1 = require("../../../context");
var ConfirmationDialog_1 = require("../../../components/ConfirmationDialog");
var useApprovalSheetManagementFooterStyles = styles_1.makeStyles(function (theme) {
    var _a = theme.variables.palette.approval, panelFooterHeight = _a.panelFooterHeight, backgroundColorBase = _a.backgroundColorBase, borderBase = _a.borderBase, borderRadiusBase = _a.borderRadiusBase;
    return {
        toolbar: {
            height: panelFooterHeight,
            minHeight: panelFooterHeight,
            boxSizing: 'border-box',
            backgroundColor: backgroundColorBase,
            borderTop: borderBase,
            borderRadius: "0 0 " + borderRadiusBase + " " + borderRadiusBase,
        },
    };
});
exports.ApprovalSheetManagementFooter = function () {
    var _a = react_1.useContext(context_1.ApprovalSheetContext), sheet = _a.sheet, saveApprovalSheetGroups = _a.saveApprovalSheetGroups, changeApprovalSheetStatus = _a.changeApprovalSheetStatus;
    var _b = react_1.useContext(ApprovalSheetManagementContext_1.ApprovalSheetManagementContext), isEditSheet = _b.isEditSheet, setIsEditSheetTrue = _b.setIsEditSheetTrue, setIsEditSheetFalse = _b.setIsEditSheetFalse, setIsAddGroupModalOpenTrue = _b.setIsAddGroupModalOpenTrue, groupsUpdated = _b.groupsUpdated, setGroupsUpdated = _b.setGroupsUpdated;
    var _c = sheet.groups, groups = _c === void 0 ? [] : _c, statusType = sheet.statusType, _d = sheet.id, id = _d === void 0 ? '' : _d;
    var isActiveSheetStatus = statusType ? utils_1.isActiveApprovalStatus(statusType) : false;
    var isResumeApprovalSheetStatus = statusType ? utils_1.isResumeApprovalStatus(statusType) : false;
    var isStartApprovalSheetStatus = statusType ? utils_1.isStartApprovalStatus(statusType) : false;
    var isInProgressApprovalSheetStatus = statusType ? utils_1.isInProgressApprovalStatus(statusType) : false;
    var isInManageableApprovalSheetStatus = statusType ? utils_1.isInManageableApprovalStatus(statusType) : false;
    var _e = react_1.useState(function () { return Promise.resolve(); }), onConfirmAction = _e[0], setOnConfirmAction = _e[1];
    var _f = react_1.useState(null), confirmButtonText = _f[0], setConfirmButtonText = _f[1];
    var resetOnConfirmAction = function () { return setOnConfirmAction(function () { return Promise.resolve(); }); };
    var resetConfirmButtonText = function () { return setConfirmButtonText(null); };
    var onConfirmDialogCancel = function () {
        resetConfirmButtonText();
        resetOnConfirmAction();
    };
    var completeSheetAction = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, changeApprovalSheetStatus(id, common_1.ApprovalSheetStatus.COMPLETED_FLOW)];
                case 1:
                    _a.sent();
                    onConfirmDialogCancel();
                    return [2 /*return*/];
            }
        });
    }); };
    var rejectSheetAction = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, changeApprovalSheetStatus(id, common_1.ApprovalSheetStatus.REJECTED_FLOW)];
                case 1:
                    _a.sent();
                    onConfirmDialogCancel();
                    return [2 /*return*/];
            }
        });
    }); };
    var completeSheetText = react_1.default.createElement(react_intl_1.FormattedMessage, { id: "completeSheetButton" });
    var rejectSheetText = react_1.default.createElement(react_intl_1.FormattedMessage, { id: "rejectSheetButton" });
    var onCompleteSheetClick = function () {
        setOnConfirmAction(function () { return completeSheetAction; });
        setConfirmButtonText(completeSheetText);
    };
    var onRejectSheetClick = function () {
        setOnConfirmAction(function () { return rejectSheetAction; });
        setConfirmButtonText(rejectSheetText);
    };
    var classes = useApprovalSheetManagementFooterStyles();
    var onSheetSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsEditSheetFalse();
                    return [4 /*yield*/, saveApprovalSheetGroups({ sheetId: id, groups: groupsUpdated })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var onSheetCancel = function () {
        setIsEditSheetFalse();
        // тут стоит выводить предупреждение о несохраненных данных
        setGroupsUpdated(groups);
    };
    var startSheet = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, changeApprovalSheetStatus(id, common_1.ApprovalSheetStatus.ACTIVE_FLOW)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var stopSheet = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, changeApprovalSheetStatus(id, common_1.ApprovalSheetStatus.STOPPED_FLOW)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var isGroupsUpdatedEmpty = react_1.useMemo(function () { return !groupsUpdated || groupsUpdated.length === 0; }, [groupsUpdated]);
    var buttonWithTooltip = function (children) {
        return isGroupsUpdatedEmpty ? (react_1.default.createElement(core_1.Tooltip, { title: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "emptyGroupsTooltip" }) },
            react_1.default.createElement("div", null, children))) : (children);
    };
    return (react_1.default.createElement(core_1.Toolbar, { className: classes.toolbar },
        react_1.default.createElement(core_1.Grid, { container: true, direction: "row", justify: "space-between", alignItems: "center" },
            react_1.default.createElement(core_1.Grid, { item: true },
                react_1.default.createElement(core_1.Grid, { container: true, alignItems: "baseline", spacing: 2, wrap: "nowrap" },
                    isInManageableApprovalSheetStatus && (react_1.default.createElement(core_1.Grid, { item: true }, isEditSheet ? (buttonWithTooltip(react_1.default.createElement(core_1.Button, { color: "primary", variant: "contained", startIcon: react_1.default.createElement(Save_1.default, null), onClick: onSheetSave, disabled: isGroupsUpdatedEmpty },
                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: "saveButton" })))) : (react_1.default.createElement(core_1.Button, { color: "primary", variant: "contained", startIcon: react_1.default.createElement(Settings_1.default, null), onClick: setIsEditSheetTrue },
                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: "settingsButton" }))))),
                    react_1.default.createElement(core_1.Grid, { item: true }, isEditSheet ? (react_1.default.createElement(core_1.Button, { color: "secondary", variant: "contained", startIcon: react_1.default.createElement(Close_1.default, null), onClick: onSheetCancel },
                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: "cancelButton" }))) : isActiveSheetStatus ? (react_1.default.createElement(core_1.Button, { color: "secondary", variant: "contained", startIcon: react_1.default.createElement(Stop_1.default, null), onClick: stopSheet },
                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: "stopButton" }))) : isResumeApprovalSheetStatus ? (buttonWithTooltip(react_1.default.createElement(core_1.Button, { color: "secondary", variant: "contained", startIcon: react_1.default.createElement(PlayArrow_1.default, null), onClick: startSheet, disabled: isGroupsUpdatedEmpty },
                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: "resumeButton" })))) : isStartApprovalSheetStatus ? (buttonWithTooltip(react_1.default.createElement(core_1.Button, { color: "secondary", variant: "contained", startIcon: react_1.default.createElement(PlayArrow_1.default, null), onClick: startSheet, disabled: isGroupsUpdatedEmpty },
                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: "playButton" })))) : null))),
            react_1.default.createElement(core_1.Grid, { item: true },
                react_1.default.createElement(core_1.Grid, { container: true, alignItems: "baseline", spacing: 2, wrap: "nowrap" }, isEditSheet ? (react_1.default.createElement(core_1.Grid, { item: true },
                    react_1.default.createElement(core_1.Button, { color: "primary", variant: "contained", startIcon: react_1.default.createElement(Add_1.default, null), onClick: setIsAddGroupModalOpenTrue },
                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: "addGroupButton" })))) : isInProgressApprovalSheetStatus ? (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(core_1.Grid, { item: true },
                        react_1.default.createElement(core_1.Button, { color: "primary", variant: "contained", onClick: onCompleteSheetClick }, completeSheetText)),
                    react_1.default.createElement(core_1.Grid, { item: true },
                        react_1.default.createElement(core_1.Button, { color: "primary", variant: "contained", onClick: onRejectSheetClick }, rejectSheetText)))) : null))),
        react_1.default.createElement(ConfirmationDialog_1.ConfirmationDialog, { id: "confirm-end-sheet", open: !!confirmButtonText, onConfirm: onConfirmAction, onCancel: onConfirmDialogCancel, confirmButtonText: confirmButtonText })));
};
